
import { mapState } from 'vuex'
import BreadcrumbsNavigation from '@/components/BreadcrumbsNavigation'
import HeroButton from '@/components/HeroButton.vue'
import StoreLocator from '@/components/StoreLocator'
import { visionExpressEyeTestUrl } from '@/utils/constants'
import tailwindConfig from '@/tailwind.config.js'

export default {
  components: {
    BreadcrumbsNavigation,
    HeroButton,
    StoreLocator,
  },
  middleware({ store, redirect }) {
    if (!store.state.app?.storeLocator?.enabled) {
      return redirect('/')
    }
  },
  data() {
    return {
      tablet: parseInt(tailwindConfig.theme.screens.tablet, 10),
      desktopMd: parseInt(tailwindConfig.theme.screens['desktop-md'], 10),
    }
  },
  head() {
    return {
      title: this.$t('storeLocator.metaTitle') || this.meta?.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('storeLocator.metaDescription') || this.meta?.description,
        },
      ],
    }
  },
  computed: {
    ...mapState(['app']),
    additionalItems() {
      return [
        {
          name: this.$t('storeLocator.breadcrumb'),
          link: null,
        },
      ]
    },
    showFreeEyeTests() {
      return this.app?.storeLocator?.showFreeEyeTests
    },
    opticianBrandLogo() {
      return this.$i18n.localeProperties.opticianBrandLogo
    },
    showStoreLocatorInline() {
      return this.app?.storeLocator?.inlineMap
    },
  },
  methods: {
    goToFreeEyeTest() {
      const path = '/account/free-eye-test'

      if (this.$auth.loggedIn) {
        this.$router.push(this.$getLink(path))
      } else {
        this.$store.commit('SET_LOGIN_REDIRECT_TO', path)
        this.$router.push(this.$getLink('/login'))
      }
    },
    goToEyeTest() {
      window.location.assign(visionExpressEyeTestUrl)
    },
    liftToLegacyStoreLocator() {
      this.$store.dispatch('liftToLegacy', 'storeLocator')
    },
  },
}
